import { domainTags } from "@/mocks/portalData";

const accents = [
  "text-primary-600 bg-primary-100",
  "text-accent-700 bg-accent-100",
  "text-secondary-700 bg-secondary-100",
  "text-foreground-700 bg-background-200",
];

export default function Domains() {
  return (
    <section id="domains" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium text-primary-600">分类导航 · CATEGORIES</p>
          <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            按圈层精准追更爆料源
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            每个领域都聚合了头部认证博主与红人账号，点进分类即可锁定该圈的核心信息来源。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3">
          {domainTags.map((d, i) => (
            <a
              key={d.label}
              href="#bloggers"
              className="group flex items-start gap-3 rounded-xl border border-background-200/70 bg-background-100/60 p-5 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${accents[i % accents.length]} text-xl`}>
                <i className={d.icon}></i>
              </span>
              <span>
                <span className="block font-heading text-base font-bold text-foreground-950">{d.label}</span>
                <span className="mt-1 block text-xs leading-relaxed text-foreground-500">{d.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}